import Footer from '../components/Footer';

const MainLayout = ({ children }) => (
  <>

    <main>{children}</main>
    {/* <Footer /> */}
  </>
);

export default MainLayout;